import { render, staticRenderFns } from "./UsersProfile.vue?vue&type=template&id=3232cb05&scoped=true&"
import script from "./UsersProfile.vue?vue&type=script&lang=js&"
export * from "./UsersProfile.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3232cb05",
  null
  
)

export default component.exports